import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ClipType } from "@air/api/types";
import { memo } from "react";
import { useSelector } from "react-redux";
import { ImageSettingsButton } from "~/components/AssetModalV2/Content/Footer/components/ImageSettingsButton";
import { ImageZoomSlider } from "~/components/AssetModalV2/Content/Footer/components/ImageZoomSlider";
import { ModeToggleSegmentedControl } from "~/components/AssetModalV2/Content/Footer/components/ModeToggleSegmentedControl";
import { PDFOutlineToggleButton } from "~/components/AssetModalV2/Content/Footer/components/PDFOutlineToggleButton";
import { PDFZoomSlider } from "~/components/AssetModalV2/Content/Footer/components/PDFZoomSlider";
import { ThemeToggleButton } from "~/components/AssetModalV2/Content/Footer/components/ThemeToggleButton";
import { centralizedClipIsPDFTypeSelector, centralizedClipTypeSelector } from "~/store/centralizedClip/selectors";
export const ContentFooter = /*#__PURE__*/ memo((param)=>{
    let { leftControls, rightControls } = param;
    const clipType = useSelector(centralizedClipTypeSelector);
    const isPdfRenderedFile = useSelector(centralizedClipIsPDFTypeSelector);
    const isPhoto = !isPdfRenderedFile && (clipType === ClipType.photo || clipType === ClipType.animated);
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex w-full items-center justify-between",
        "data-testid": "CONTENT_FOOTER",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-1",
                "data-testid": "CONTENT_FOOTER_LEFT",
                children: [
                    isPhoto && /*#__PURE__*/ _jsx(ImageZoomSlider, {}),
                    isPdfRenderedFile && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(PDFOutlineToggleButton, {}),
                            /*#__PURE__*/ _jsx(PDFZoomSlider, {})
                        ]
                    }),
                    leftControls
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                "data-testid": "CONTENT_FOOTER_CENTER",
                children: /*#__PURE__*/ _jsx(ModeToggleSegmentedControl, {})
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-1",
                "data-testid": "CONTENT_FOOTER_RIGHT",
                children: [
                    /*#__PURE__*/ _jsx(ThemeToggleButton, {}),
                    isPhoto && /*#__PURE__*/ _jsx(ImageSettingsButton, {}),
                    rightControls
                ]
            })
        ]
    });
});
ContentFooter.displayName = "ContentFooter";
